module.exports = __webpack_public_path__ + "img/keycap-digit-six.b0547a1e.png";